const C = {
  surface: "var(--bc-panel, #18181B)", highlight: "var(--bc-panel-elev, #27272A)", border: "var(--bc-border, #27272A)",
  text: "var(--bc-ink, #FAFAFA)", muted: "var(--bc-sub, #A1A1AA)", green: "#22C55E",
  red: "#EF4444", blue: "#3B82F6",
};

const FORM_COLORS = { W: C.green, D: C.muted, L: C.red };

export default function StandingsTable({ standings, homeTeamId, awayTeamId }) {
  if (!standings || standings.length === 0) return null;

  const homeRank = standings.find((s) => s.team?.id === homeTeamId)?.rank;
  const awayRank = standings.find((s) => s.team?.id === awayTeamId)?.rank;

  return (
    <div style={{ background: C.surface, border: `1px solid ${C.border}` }} data-testid="standings-table">
      <div className="px-4 py-3 flex items-center justify-between" style={{ borderBottom: `1px solid ${C.border}` }}>
        <span className="font-heading font-bold text-sm uppercase tracking-widest" style={{ color: C.text }}>CLASSIFICA</span>
        <div className="flex items-center gap-3">
          <span className="font-data text-xs" style={{ color: C.muted }}>
            {homeRank && awayRank && `Pos. ${homeRank} vs ${awayRank}`}
          </span>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full" style={{ borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: C.highlight }}>
              {["#", "SQUADRA", "G", "V", "P", "S", "GF", "GS", "DR", "PT"].map((h) => (
                <th key={h} className={`font-data text-xs uppercase py-2 px-2 ${h === "SQUADRA" ? "text-left" : "text-center"}`}
                  style={{ color: C.muted }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {standings.map((row, i) => {
              const isHome = row.team?.id === homeTeamId;
              const isAway = row.team?.id === awayTeamId;
              const highlight = isHome || isAway;
              const rowBg = isHome ? "rgba(34,197,94,0.06)" : isAway ? "rgba(239,68,68,0.06)" : i % 2 === 0 ? C.surface : "#1C1C1F";
              const borderColor = isHome ? C.green : isAway ? C.red : "transparent";

              return (
                <tr
                  key={`${row.team?.id}-${i}`}
                  style={{
                    background: rowBg,
                    borderBottom: `1px solid ${C.highlight}`,
                    borderLeft: `2px solid ${borderColor}`,
                  }}
                  data-testid={highlight ? `standings-team-${row.team?.id}` : undefined}
                >
                  <td className="font-data text-xs py-2.5 px-2 text-center" style={{ color: C.muted }}>{row.rank}</td>
                  <td className="py-2.5 px-2">
                    <div className="flex items-center gap-2">
                      <img src={row.team?.logo} alt="" className="w-4 h-4 object-contain flex-shrink-0"
                        onError={(e) => e.target.style.display = "none"} />
                      <span className={`font-heading font-bold text-xs uppercase truncate max-w-[120px]`}
                        style={{ color: highlight ? (isHome ? C.green : C.red) : C.text }}>
                        {row.team?.name}
                      </span>
                    </div>
                  </td>
                  {[row.played, row.wins, row.draws, row.losses, row.gf, row.ga, row.gd, row.points].map((v, j) => (
                    <td key={j} className={`font-data text-xs py-2.5 px-2 text-center ${j === 7 ? "font-medium" : ""}`}
                      style={{ color: j === 7 ? C.text : C.muted }}>
                      {v ?? "-"}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
